import Middleware from './middleware'
import { Auth, authMiddleware, ExpiredAuthSessionError } from '~auth/runtime'

// Active schemes
import { Oauth2Scheme } from '~auth/runtime'

Middleware.auth = authMiddleware

export default function (ctx, inject) {
  // Options
  const options = {
  "resetOnError": false,
  "ignoreExceptions": false,
  "scopeKey": "scope",
  "rewriteRedirects": true,
  "fullPathRedirect": false,
  "watchLoggedIn": true,
  "redirect": {
    "login": "/login",
    "logout": "/",
    "home": "/",
    "callback": "/callback"
  },
  "cookie": false,
  "localStorage": {
    "prefix": "auth."
  },
  "defaultStrategy": "bamidp"
}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Register strategies
  // bamidp
  $auth.registerStrategy('bamidp', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.bigadvance.app/oidc/bank/auth",
    "token": "https://idp.bigadvance.app/oidc/bank/token",
    "logout": "https://idp.bigadvance.app/oidc/bank/auth/logout"
  },
  "name": "bamidp"
}))

  // bamidp_bank0130
  $auth.registerStrategy('bamidp_bank0130', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0130/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0130/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0130/logout"
  },
  "name": "bamidp_bank0130"
}))

  // bamidp_bank0164
  $auth.registerStrategy('bamidp_bank0164', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0164/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0164/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0164/logout"
  },
  "name": "bamidp_bank0164"
}))

  // bamidp_bank0175
  $auth.registerStrategy('bamidp_bank0175', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0175/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0175/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0175/logout"
  },
  "name": "bamidp_bank0175"
}))

  // bamidp_bank0182
  $auth.registerStrategy('bamidp_bank0182', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0182/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0182/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0182/logout"
  },
  "name": "bamidp_bank0182"
}))

  // bamidp_bank0501
  $auth.registerStrategy('bamidp_bank0501', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0501/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0501/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0501/logout"
  },
  "name": "bamidp_bank0501"
}))

  // bamidp_bank0543
  $auth.registerStrategy('bamidp_bank0543', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0543/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0543/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0543/logout"
  },
  "name": "bamidp_bank0543"
}))

  // bamidp_bank0576
  $auth.registerStrategy('bamidp_bank0576', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0576/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0576/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0576/logout"
  },
  "name": "bamidp_bank0576"
}))

  // bamidp_bank0585
  $auth.registerStrategy('bamidp_bank0585', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0585/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0585/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0585/logout"
  },
  "name": "bamidp_bank0585"
}))

  // bamidp_bank1320
  $auth.registerStrategy('bamidp_bank1320', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1320/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1320/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1320/logout"
  },
  "name": "bamidp_bank1320"
}))

  // bamidp_bank1341
  $auth.registerStrategy('bamidp_bank1341', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1341/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1341/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1341/logout"
  },
  "name": "bamidp_bank1341"
}))

  // bamidp_bank1532
  $auth.registerStrategy('bamidp_bank1532', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1532/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1532/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1532/logout"
  },
  "name": "bamidp_bank1532"
}))

  // bamidp_bank1557
  $auth.registerStrategy('bamidp_bank1557', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1557/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1557/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1557/logout"
  },
  "name": "bamidp_bank1557"
}))

  // bamidp_bank1440
  $auth.registerStrategy('bamidp_bank1440', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1440/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1440/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1440/logout"
  },
  "name": "bamidp_bank1440"
}))

  // bamidp_bank1560
  $auth.registerStrategy('bamidp_bank1560', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1560/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1560/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1560/logout"
  },
  "name": "bamidp_bank1560"
}))

  // bamidp_bank1602
  $auth.registerStrategy('bamidp_bank1602', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1602/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1602/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1602/logout"
  },
  "name": "bamidp_bank1602"
}))

  // bamidp_bank1636
  $auth.registerStrategy('bamidp_bank1636', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1636/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1636/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1636/logout"
  },
  "name": "bamidp_bank1636"
}))

  // bamidp_bank1668
  $auth.registerStrategy('bamidp_bank1668', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1668/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1668/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1668/logout"
  },
  "name": "bamidp_bank1668"
}))

  // bamidp_bank1738
  $auth.registerStrategy('bamidp_bank1738', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1738/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1738/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1738/logout"
  },
  "name": "bamidp_bank1738"
}))

  // bamidp_bank1996
  $auth.registerStrategy('bamidp_bank1996', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1996/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1996/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1996/logout"
  },
  "name": "bamidp_bank1996"
}))

  // bamidp_bank0117
  $auth.registerStrategy('bamidp_bank0117', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0117/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0117/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0117/logout"
  },
  "name": "bamidp_bank0117"
}))

  // bamidp_bank0121
  $auth.registerStrategy('bamidp_bank0121', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0121/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0121/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0121/logout"
  },
  "name": "bamidp_bank0121"
}))

  // bamidp_bank0123
  $auth.registerStrategy('bamidp_bank0123', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0123/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0123/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0123/logout"
  },
  "name": "bamidp_bank0123"
}))

  // bamidp_bank0126
  $auth.registerStrategy('bamidp_bank0126', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0126/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0126/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0126/logout"
  },
  "name": "bamidp_bank0126"
}))

  // bamidp_bank0143
  $auth.registerStrategy('bamidp_bank0143', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0143/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0143/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0143/logout"
  },
  "name": "bamidp_bank0143"
}))

  // bamidp_bank0147
  $auth.registerStrategy('bamidp_bank0147', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0147/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0147/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0147/logout"
  },
  "name": "bamidp_bank0147"
}))

  // bamidp_bank0163
  $auth.registerStrategy('bamidp_bank0163', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0163/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0163/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0163/logout"
  },
  "name": "bamidp_bank0163"
}))

  // bamidp_bank0179
  $auth.registerStrategy('bamidp_bank0179', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0179/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0179/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0179/logout"
  },
  "name": "bamidp_bank0179"
}))

  // bamidp_bank0183
  $auth.registerStrategy('bamidp_bank0183', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0183/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0183/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0183/logout"
  },
  "name": "bamidp_bank0183"
}))

  // bamidp_bank0184
  $auth.registerStrategy('bamidp_bank0184', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0184/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0184/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0184/logout"
  },
  "name": "bamidp_bank0184"
}))

  // bamidp_bank0509
  $auth.registerStrategy('bamidp_bank0509', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0509/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0509/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0509/logout"
  },
  "name": "bamidp_bank0509"
}))

  // bamidp_bank0512
  $auth.registerStrategy('bamidp_bank0512', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0512/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0512/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0512/logout"
  },
  "name": "bamidp_bank0512"
}))

  // bamidp_bank0516
  $auth.registerStrategy('bamidp_bank0516', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0516/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0516/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0516/logout"
  },
  "name": "bamidp_bank0516"
}))

  // bamidp_bank0517
  $auth.registerStrategy('bamidp_bank0517', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0517/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0517/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0517/logout"
  },
  "name": "bamidp_bank0517"
}))

  // bamidp_bank0525
  $auth.registerStrategy('bamidp_bank0525', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0525/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0525/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0525/logout"
  },
  "name": "bamidp_bank0525"
}))

  // bamidp_bank0532
  $auth.registerStrategy('bamidp_bank0532', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0532/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0532/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0532/logout"
  },
  "name": "bamidp_bank0532"
}))

  // bamidp_bank0542
  $auth.registerStrategy('bamidp_bank0542', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0542/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0542/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0542/logout"
  },
  "name": "bamidp_bank0542"
}))

  // bamidp_bank0566
  $auth.registerStrategy('bamidp_bank0566', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0566/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0566/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0566/logout"
  },
  "name": "bamidp_bank0566"
}))

  // bamidp_bank0578
  $auth.registerStrategy('bamidp_bank0578', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0578/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0578/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0578/logout"
  },
  "name": "bamidp_bank0578"
}))

  // bamidp_bank0582
  $auth.registerStrategy('bamidp_bank0582', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0582/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0582/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0582/logout"
  },
  "name": "bamidp_bank0582"
}))

  // bamidp_bank0594
  $auth.registerStrategy('bamidp_bank0594', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0594/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0594/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0594/logout"
  },
  "name": "bamidp_bank0594"
}))

  // bamidp_bank0596
  $auth.registerStrategy('bamidp_bank0596', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank0596/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank0596/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank0596/logout"
  },
  "name": "bamidp_bank0596"
}))

  // bamidp_bank1240
  $auth.registerStrategy('bamidp_bank1240', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1240/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1240/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1240/logout"
  },
  "name": "bamidp_bank1240"
}))

  // bamidp_bank1253
  $auth.registerStrategy('bamidp_bank1253', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1253/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1253/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1253/logout"
  },
  "name": "bamidp_bank1253"
}))

  // bamidp_bank1260
  $auth.registerStrategy('bamidp_bank1260', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1260/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1260/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1260/logout"
  },
  "name": "bamidp_bank1260"
}))

  // bamidp_bank1280
  $auth.registerStrategy('bamidp_bank1280', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1280/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1280/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1280/logout"
  },
  "name": "bamidp_bank1280"
}))

  // bamidp_bank1283
  $auth.registerStrategy('bamidp_bank1283', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1283/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1283/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1283/logout"
  },
  "name": "bamidp_bank1283"
}))

  // bamidp_bank1286
  $auth.registerStrategy('bamidp_bank1286', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1286/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1286/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1286/logout"
  },
  "name": "bamidp_bank1286"
}))

  // bamidp_bank1360
  $auth.registerStrategy('bamidp_bank1360', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1360/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1360/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1360/logout"
  },
  "name": "bamidp_bank1360"
}))

  // bamidp_bank1370
  $auth.registerStrategy('bamidp_bank1370', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1370/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1370/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1370/logout"
  },
  "name": "bamidp_bank1370"
}))

  // bamidp_bank1373
  $auth.registerStrategy('bamidp_bank1373', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1373/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1373/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1373/logout"
  },
  "name": "bamidp_bank1373"
}))

  // bamidp_bank1385
  $auth.registerStrategy('bamidp_bank1385', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1385/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1385/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1385/logout"
  },
  "name": "bamidp_bank1385"
}))

  // bamidp_bank1393
  $auth.registerStrategy('bamidp_bank1393', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1393/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1393/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1393/logout"
  },
  "name": "bamidp_bank1393"
}))

  // bamidp_bank1396
  $auth.registerStrategy('bamidp_bank1396', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1396/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1396/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1396/logout"
  },
  "name": "bamidp_bank1396"
}))

  // bamidp_bank1470
  $auth.registerStrategy('bamidp_bank1470', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1470/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1470/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1470/logout"
  },
  "name": "bamidp_bank1470"
}))

  // bamidp_bank1502
  $auth.registerStrategy('bamidp_bank1502', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1502/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1502/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1502/logout"
  },
  "name": "bamidp_bank1502"
}))

  // bamidp_bank1533
  $auth.registerStrategy('bamidp_bank1533', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1533/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1533/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1533/logout"
  },
  "name": "bamidp_bank1533"
}))

  // bamidp_bank1674
  $auth.registerStrategy('bamidp_bank1674', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1674/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1674/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1674/logout"
  },
  "name": "bamidp_bank1674"
}))

  // bamidp_bank1685
  $auth.registerStrategy('bamidp_bank1685', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1685/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1685/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1685/logout"
  },
  "name": "bamidp_bank1685"
}))

  // bamidp_bank1692
  $auth.registerStrategy('bamidp_bank1692', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1692/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1692/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1692/logout"
  },
  "name": "bamidp_bank1692"
}))

  // bamidp_bank1752
  $auth.registerStrategy('bamidp_bank1752', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1752/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1752/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1752/logout"
  },
  "name": "bamidp_bank1752"
}))

  // bamidp_bank1991
  $auth.registerStrategy('bamidp_bank1991', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank1991/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank1991/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank1991/logout"
  },
  "name": "bamidp_bank1991"
}))

  // bamidp_bank2010
  $auth.registerStrategy('bamidp_bank2010', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank2010/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank2010/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank2010/logout"
  },
  "name": "bamidp_bank2010"
}))

  // bamidp_bank2360
  $auth.registerStrategy('bamidp_bank2360', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank2360/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank2360/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank2360/logout"
  },
  "name": "bamidp_bank2360"
}))

  // bamidp_bank2680
  $auth.registerStrategy('bamidp_bank2680', new Oauth2Scheme($auth, {
  "token": {
    "property": "id_token",
    "type": "Bearer",
    "maxAge": 1800
  },
  "refreshToken": {
    "property": "refresh_token",
    "maxAge": 2592000
  },
  "responseType": "code",
  "grantType": "authorization_code",
  "clientId": "big-advance",
  "scope": [
    "openid"
  ],
  "endpoints": {
    "authorization": "https://idp.kkpp.bigadvance.app/oidc/bank2680/auth",
    "token": "https://idp.kkpp.bigadvance.app/oidc/bank2680/token",
    "logout": "https://idp.kkpp.bigadvance.app/oidc/bank2680/logout"
  },
  "name": "bamidp_bank2680"
}))

  // Inject it to nuxt context as $auth
  inject('auth', $auth)
  ctx.$auth = $auth

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.client) {
      // Don't console log expired auth session errors. This error is common, and expected to happen.
      // The error happens whenever the user does an ssr request (reload/initial navigation) with an expired refresh
      // token. We don't want to log this as an error.
      if (error instanceof ExpiredAuthSessionError) {
        return
      }

      console.error('[ERROR] [AUTH]', error)
    }
  })
}
